import customFetch from "./apicall/api";

export function logout(otherscreen = null) {
  console.log(api_token);
  let api_token = localStorage.getItem("api_token");
  customFetch(process.env.REACT_APP_URL + "/new/logout", {
    method: "POST",
    headers: { "api-token": api_token },
    //body: formdata,
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (otherscreen != null) {
        window.history.back();
      } else {
        //const formdata = new FormData();
        console.log(data);
        localStorage.clear();
        window.location.href = "/";
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

export function netspeed() {
  return navigator.connection.downlink > 1
    ? navigator.connection.downlink + " Mb/s"
    : navigator.connection.downlink + " Kb/s";
}

// Add the chkapiinput function
export function chkapiinput(arr) {
  // Validate that all values in the array are non-null, non-undefined, and non-empty
  return arr.every((value) => value !== null && value !== undefined && value !== "");
}

export function generateId(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export async function fetchFilesFromPublicPath(path, api_token = null, options = {}) {
  const {
    component = "KYCDocuments",
    api_group_id = "",
    user_id = localStorage.getItem("in_userid"),
  } = options;

  const files = [];

  const addFile = (filePath) => {
    const fileName = filePath.split("/").pop();
    files.push({ name: fileName, url: filePath });
  };

  if (typeof path === "object" && path !== null) {
    const recursiveSearch = (obj) => {
      for (const key in obj) {
        if (key === "file_path" && obj[key]) {
          addFile(obj[key]);
          return true;
        }

        if (typeof obj[key] === "object" && obj[key] !== null) {
          const found = recursiveSearch(obj[key]);
          if (found) return true;
        }
      }
      return false;
    };

    recursiveSearch(path);
  } else if (typeof path === "string") {
    const filename = path.substring(path.lastIndexOf("/") + 1);
    files.push({ name: filename, url: path });
  }

  if (files.length === 0) {
    throw new Error("No file path found to download");
  }

  const downloadedFiles = [];

  for (const file of files) {
    const generate_Id1 = generateId(10);
    const generate_Id = generateId(10);

    const requestOptions = {
      method: "POST",
      headers: {
        "api-token": api_token || localStorage.getItem("api_token"),
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id,
        component,
        user_id,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ source_blob_name: file.url }),
    };

    const response = await customFetch(
      process.env.REACT_APP_FILE_DOWNLOAD + "/gcs/download",
      requestOptions
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch file ${file.url}`);
    }

    const blob = await response.blob();
    downloadedFiles.push({
      name: file.name,
      url: URL.createObjectURL(blob),
      mimeType: blob.type,
      blob,
    });
  }

  return downloadedFiles;
}
